import React, { useEffect, useState } from "react";
import Card from "react-bootstrap/Card";
import { Icons } from "../../atoms/Icons";
import BarChart from "../../atoms/BarChart";
import "./savingsbreakdown.scss";
import Buttons from "../../atoms/Buttons";
import { Col, Row } from "react-bootstrap";
import Carousel from "../../atoms/Carousel";
import { addCommas, formattedDate } from "../../helpers/helpers";
import { Link, useNavigate } from "react-router-dom";

const SavingsBreakdownModal = (props) => {
  const navigate = useNavigate();
  const data = props.potData.data;
  const [isHovered, setIsHovered] = useState(true);

  const handleMouseEnter = () => {
    setIsHovered(false);
  };
  const handleMouseLeave = () => {
    setIsHovered(true);
  };

  let activeData = [];
  let nonActiveData = [];
  let finalValue = [];
  const [displayPlusIcon, setDisplayPlusIcon] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setDisplayPlusIcon(true);
    }, 1);
    return () => clearInterval(interval);
  }, []);

  const savingSummary = () => {
    props.handleCloseButton();
    navigate("/savings");
  };

  activeData = data.savingPots.savings.filter((item) => {
    return item.status === "Active";
  });

  nonActiveData = data.savingPots.savings.filter((item) => {
    return item.status !== "Active";
  });

  let potValueData = [...activeData, ...nonActiveData];

  let dbPension = {
    dbPension: data.dbPension,
  };

  finalValue =
    potValueData.length > 0 && data.dbPension === true
      ? [...potValueData, dbPension]
      : potValueData.length > 0 && data.drawdownPots.drawdown.length > 0
        ? [...potValueData, ...data.drawdownPots.drawdown]
        : data.drawdownPots.drawdown.length > 0
          ? data.drawdownPots.drawdown
          : potValueData;

  return (
    <div>
      <Card className="savings-breakdown-modal-card">
        <div className="small-close">
          <Link to="" aria-label="Close savings breakdown modal">
            <Icons
              iconname="close"
              variant="icon-sixteen-px"
              clickHandler={props.handleCloseButton}
            />
          </Link>
        </div>
        <Card.Title>
          {displayPlusIcon ? (
            <div className="savings-breakdown-modal-title">Your total pots</div>
          ) : (
            ""
          )}
        </Card.Title>
        <Card.Body>
          <div className="chart-center">
            <div className="chart-size">
              {/* both savings Drawdown case */}
              {data.savingPots.savings.length > 0 && data.dbPension ? (
                <Row>
                  <Col lg={9} md={9}>
                    <BarChart
                      data={data}
                      savings={true}
                      drawDown={false}
                      showLine={false}
                    />
                  </Col>
                  <Col lg={3} md={3} className="db-pension-container">
                    <div className="plus-icon">
                      <Icons iconname="plus" variant="icon-sixteen-px" />
                    </div>
                    <Card className="db-card">
                      <div className="db-text">
                        <div className="db-pension-text">
                          You also have a DB pension
                        </div>
                        <div>
                          <Link to="">
                            <span className="icon">
                              <Icons
                                iconname="edit"
                                variant="icon-twenty-four-px"
                              />
                            </span>
                            <Buttons className="tertiary" name="View it here" />
                          </Link>
                        </div>
                      </div>
                    </Card>
                  </Col>
                </Row>
              ) : data.savingPots.savings.length > 0 &&
                data.drawdownPots.drawdown.length > 0 ? (
                <Row>
                  <Col lg={6} md={6}>
                    <BarChart data={data} savings={true} showLine={true} />
                  </Col>
                  <Col lg={6} md={6}>
                    <BarChart data={data} drawDown={true} showLine={true} />
                  </Col>
                </Row>
              ) : data.savingPots.savings.length > 0 ? (
                <Row>
                  <Col lg={12} md={12}>
                    <BarChart
                      data={data}
                      savings={true}
                      drawDown={false}
                      showLine={false}
                      data-testid="bar-chart"
                    />
                  </Col>
                </Row>
              ) : data.drawdownPots.drawdown.length > 0 ? (
                <Row>
                  <Col lg={12} md={12}>
                    <BarChart
                      data={data}
                      drawDown={true}
                      savings={false}
                      showLine={false}
                    />
                  </Col>
                </Row>
              ) : data.dbPension ? (
                ""
              ) : (
                ""
              )}
              {/* only saving case */}

              {/* only drawdown case */}

              {/* DB pensionCase */}
            </div>
          </div>
          <Col className="savings-breakdown-modal-carousel mb-4 mt-4">
            {data.savingPots.savings.length === 1 &&
            data.drawdownPots.drawdown.length === 0 &&
            data.dbPension !== true ? (
              <div className="savings-card-text-wrapper">
                <div className="savings-card-text">
                  <span>{data.savingPots.savings[0].employerId}</span>
                  <span>{data.savingPots.savings[0].employerName}</span>
                  <span>{data.savingPots.savings[0].totalBalance}</span>
                </div>
              </div>
            ) : data.savingPots.savings.length === 0 &&
              data.drawdownPots.drawdown.length === 1 ? (
              <div className="drawdown-card-text-wrapper">
                <div className="savings-card-text">
                  <span>{data.savingPots.savings[0].employerId}</span>
                  <span>{data.savingPots.savings[0].employerName}</span>
                  <span>{data.savingPots.savings[0].totalBalance}</span>
                </div>
              </div>
            ) : (
              <Carousel
                savingsBreakdownCarouselData={finalValue}
                type="Savings Breakdown"
                interval={null}
                savingsBreakdownData={data}
              />
            )}
            <div className="mt-4 total-value-wrapper">
              <span className="total-value-text">Total value</span>
              <span className="total-value">
                £
                {addCommas(
                  Math.trunc(
                    data.savingPots.totalSavingsValue +
                      data.drawdownPots.totalDrawdownValue, //eslint-disable-line
                  ), //eslint-disable-line
                )}
                .
                <span className="small-digits">
                  {(
                    (data.savingPots.totalSavingsValue +
                      data.drawdownPots.totalDrawdownValue) %
                    1
                  )
                    .toFixed(2)
                    .substring(2)}
                </span>
              </span>
            </div>
          </Col>
          <div className="savings-button">
            <Buttons
              className="primary"
              name="Go to savings summary"
              iconname={isHovered ? "arrow-right-white" : "arrow-right"}
              variantname="icon-sixteen-px"
              handleClick={savingSummary}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            />
          </div>
          <div className="container pot-footer-wrapper">
            <span className="pot-footer-text">{props.aboutTptModalText}</span>
            <span className="pot-footer-text">
              Figures correct as of {formattedDate(props.asOfDate.asOn)}
            </span>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default SavingsBreakdownModal;
